<div class="lm-module-content">

    @if (state?.selectedCategory === '_start_') {
        <div class="lm-card-content">
            <p class="section-title lm-card-section-title">{{ 'Facade_CreateNewReport' | translate }}</p>
<!--            <h4>Start from a recent business class.</h4>-->
        </div>
        <div class="lm-facade-cards-wrapper">
            @if (suggestedBusinessObjects) {
                @for (suggestedBusinessObject of suggestedBusinessObjects; track suggestedBusinessObject) {
                    <lm-facade-tile
                            [title]="suggestedBusinessObject.title"
                            [description]="suggestedBusinessObject.description"
                            [businessObject]="suggestedBusinessObject"
                            [category]="suggestedBusinessObject.category"
                            [subCategory]="suggestedBusinessObject.subcategory"
                            [selected]="suggestedBusinessObject === selectedBusinessObject"
                            [showIcon]="false"
                            [cardWidth]="moduleCardWidth()"
                            (businessObjectClicked)="onBusinessObjectClicked($event)"
                    ></lm-facade-tile>
                } @empty {
                    <div class="empty-title">
                        <span>{{ 'Facade_SuggestedEmptyMessage' | translate }}</span>
                    </div>
                }
            }
        </div>
        @if (suggestedTemplates.length > 0) {
            <div class="lm-card-content">
                <p class="section-title lm-card-section-title">{{ 'Facade_CopyExistingReport' | translate }}</p>
<!--                <h4>Copy from an existing report.</h4>-->
            </div>
            <div class="lm-facade-cards-wrapper">
                @for(suggestedTemplate of suggestedTemplates; track suggestedTemplate) {
                  <lm-facade-tile
                    [title]="suggestedTemplate.reportName"
                    [description]="suggestedTemplate.description"
                    [template]="suggestedTemplate"
                    [owner]="suggestedTemplate.owner.length > 0 ? suggestedTemplate.owner : 'Infor'"
                    [selected]="suggestedTemplate === selectedTemplate"
                    [showIcon]="true"
                    [cardWidth]="moduleCardWidth()"
                    (templateClicked)="onTemplateClicked($event)"
                  ></lm-facade-tile>
                }
            </div>
        }
    } @else {
        <div class="lm-module-header">
            <div class="lm-module-icon">
                <span class="image-initials large {{ moduleColor() }}">{{ moduleInitials()}}</span>
            </div>
            <div class="lm-card-content">
                <p class="section-title lm-bold lm-card-section-title">{{ selectedModule.title }}</p>
            </div>
            <div class="lm-view-toggle">
            <lm-facade-toggle-button (toggleButtonClicked)="viewClicked($event)"></lm-facade-toggle-button>
            </div>
        </div>
        @if (state.view === "tiles") {

            <soho-accordion [allowOnePane]="true" [displayChevron]="true">
                @for (section of selectedModule.sections; track section.title) {
                    @if ($first) {
                        <soho-accordion-header id="'primary'">
                            <a href="#">
                                <span class="lm-bold">{{ 'Primary' | translate }}</span>
                            </a>
                        </soho-accordion-header >
                    } @else {
                        <soho-accordion-header id="{{section.title }}">
                            <a href="#">
                                <span class="lm-bold">{{ section.title }}</span>
                            </a>
                        </soho-accordion-header >
                    }
                    <soho-accordion-pane>
                        <div class="lm-facade-cards-wrapper">
                            @for(businessObject of section.businessObjects; track businessObject) {
                                <lm-facade-tile
                                        [title]="businessObject.title"
                                        [description]="businessObject.description"
                                        [businessObject]="businessObject"
                                        [selected]="businessObject === selectedBusinessObject"
                                        [cardWidth]="moduleCardWidth()"
                                        (businessObjectClicked)="onBusinessObjectClicked($event)"
                                ></lm-facade-tile>
                            } @empty {
                                <div class="empty-title">
                                    <span>{{ 'Facade_BusinessObjectsEmptyMessage' | translate }}</span>
                                </div>
                            }
                        </div>
                    </soho-accordion-pane>
            } @empty {
                    <div class="empty-title">
                        <span>{{ 'Facade_SectionsEmptyMessage' | translate }}</span>
                    </div>
            }
            </soho-accordion>

        } @else {
            <div class="lm-facade-data-grid-wrapper">
                <soho-toolbar-flex>
                    <soho-toolbar-flex-section [isTitle]="true">{{ 'Facade_BusinessObjects' | translate }}</soho-toolbar-flex-section>
                    <soho-toolbar-flex-section [isButtonSet]="true">
                        <button soho-button="icon"
                            [icon]="'search'"
                            (click)="toggleDataGridSearch()"
                            lm-tooltip [content]="toggleSearchLabel"
                        ><span class="audible">{{toggleSearchLabel}}</span></button>
                    </soho-toolbar-flex-section>
                </soho-toolbar-flex>
                <div soho-datagrid
                    data-automation-id="lm-field-picker-data-grid"
                    class="lm-facade-field-picker-data-grid"
                    [gridOptions]="moduleGridOptions"
                    [data]="moduleGridData"
                    (rowClicked)="onRowClicked($event)">
                </div>
            </div>
        }
}
</div>

@if(showDetails()) {
  <lm-facade-report-template-detail
      [reportTemplateDetail]="facadeDetailRequest.detail"
  ></lm-facade-report-template-detail>
}
